import { FormikTextarea } from "../FormikFields/FormikTextarea.js";
import { FormikFilesPicker } from "../../modules/Files/shared/FormikFilesPicker.js";
import { FilesListDisplay } from "../../modules/Files/shared/FilesListDisplay.js";
import { useState } from "react";
import { Button, FormLayout, Icon, Modal } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdOutlineAttachment } from "react-icons/md";
import { Formik } from "formik";
//#region src/components/Comments/CommentForm.tsx
var initialValuesDefault = {
	body: "",
	fileUrls: []
};
var CommentForm = ({ commentId, initialValues, onSubmit }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	return /* @__PURE__ */ jsx(Formik, {
		initialValues: {
			...initialValuesDefault,
			...initialValues
		},
		onSubmit: async (values, actions) => {
			await onSubmit(values);
			actions.resetForm();
		},
		children: ({ isSubmitting, submitForm, values }) => /* @__PURE__ */ jsxs(FormLayout, {
			dividers: "space",
			space: "0",
			loading: isSubmitting,
			children: [
				/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(FilesListDisplay, { fileUrls: values.fileUrls || [] }), /* @__PURE__ */ jsx(FormikTextarea, {
					name: "body",
					value: values.body
				})] }),
				/* @__PURE__ */ jsx("div", {
					className: "mt-xs",
					children: /* @__PURE__ */ jsx(FormLayout.Controls, {
						onSubmit: submitForm,
						submitLabel: commentId ? "Edit" : "Comment",
						extraEnd: /* @__PURE__ */ jsxs(Button, {
							className: "space-x-xxs",
							subtle: true,
							variant: "main",
							onClick: () => setIsModalOpen(true),
							children: [/* @__PURE__ */ jsx(Icon, { Icon: MdOutlineAttachment }), !values.fileUrls?.length ? /* @__PURE__ */ jsx("span", { children: "Add Files" }) : /* @__PURE__ */ jsx("span", { children: "Edit Files" })]
						})
					})
				}),
				isModalOpen && /* @__PURE__ */ jsx(Modal, {
					header: "Comment Files",
					closeHandler: () => setIsModalOpen(false),
					children: /* @__PURE__ */ jsx("div", {
						className: "bg-surface-subtle p-xxl text-color-subtle rounded text-center italic",
						children: /* @__PURE__ */ jsx(FormikFilesPicker, {
							name: "fileUrls",
							multi: true
						})
					})
				})
			]
		})
	});
};
//#endregion
export { CommentForm };

//# sourceMappingURL=CommentForm.js.map